export default __webpack_public_path__ + "static/media/icon-back.e880f87b.svg";